import * as React                              from 'react';
import { NavLink }                             from 'react-router-dom';
import * as cx                                 from 'classnames';
import Ago                                     from '../../components/Ago';
import {
    capitalizeFirstLetter,
    obfuscatePhoneNumber
}                                              from '../../helpers/stringUtils';
import icons                                   from '../../icons';
import { ConversationListItem, MessageDeliveryStatuses, MessageActions }                from '../../types';

export interface ConversationProps {
    conversation: ConversationListItem,
    handleClick: (conversationId: string) => void,
}

const ConversationListItem: React.StatelessComponent<ConversationProps> = ({ conversation, handleClick }) => {
    const hasErrorMessage = conversation.last_message.delivery_status === MessageDeliveryStatuses.ERROR;
    const unreadCountBadge = Boolean(parseInt(conversation.unread_message_count, 10)) && !hasErrorMessage && <div className="conversation__unreadCount">{conversation.unread_message_count}</div>;

    return (
        <NavLink
            activeClassName="conversation-selected"
            onClick={() => handleClick(conversation.id)}
            className={cx(
                'conversation',
                {
                    'conversation-unread': Boolean(conversation.unread_message_count),
                    'conversation-error': hasErrorMessage
                }
            )}
            to={`/conversation/${conversation.id}`}
        >
            <div className="conversation__container">
                <div className="conversation__wrapper">
                    <div className="conversation__action">
                        {conversation.last_message.action === MessageActions.SEND ?
                        icons.upRightArrow :
                        icons.downLeftArrow}
                    </div>
                    <div className="conversation__island">
                        <div className="conversation__upper">
                            <div className="conversation__recipientName">
                                {capitalizeFirstLetter(conversation.recipient ?
                                    conversation.recipient.name : null) ||
                                    obfuscatePhoneNumber(conversation.recipient.phone_number)}
                            </div>
                            <div className="conversation__age">
                                <Ago time={conversation.last_message.date_added} />
                            </div>
                        </div>
                        <div className="conversation__lower">
                            <div className="conversation__message">
                                {conversation.last_message.content}
                            </div>
                            {unreadCountBadge}
                            {hasErrorMessage && <div className="conversation__errorIcon">{icons.alertCircle}</div>}
                        </div>
                    </div>
                    <div className="conversation__chevron">
                        {icons.chevronRightSubtle}
                    </div>
                </div>
            </div>
        </NavLink>
    );
};

export default ConversationListItem;



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationListItem.tsx